<template>
  <Imgsee ref="Imgsee" :url="info.url" :name='info.title || info.origin_name' v-if="visible && info.type == 3"
    @close="visible = false"></Imgsee>

  <div class="filebox" v-else>
    <drag-modal :visible="visible" @cancel="() => visible = false" :title='info.title' width='740px' :zIndex='10001'>
      <a :href="downFile(info)" target="_blank" :download="info.title || info.origin_name" class="down">下载</a>
      <!-- <a-button icon="download" class="down" @click="download(info)">下载</a-button> -->
      <video :src="info.url" v-if='info.type == 0' controls="controls" width='100%' height='600'></video>
      <video :src="info.url" v-if='info.type == 5' controls="controls" width='100%' height='30'></video>
      <audio :src="info.url" v-if='info.type == 1' controls="controls" width='100%' height='600'></audio>
      <iframe :src="info.url" v-if='info.type == 2' frameborder="0" width='100%' height='600'></iframe>
      <div class="amrPLay" v-if='info.type == 6'>
        <div class="yingping">
          <a-button @click="playstop()" v-show="!shpzt">暂停</a-button>
          <a-button @click="play(info.url)" v-show="shpzt">播放</a-button>
          <input class="amr-progress" type="range" min="0" max="1" step="any" :value="ypdt" disabled>
          <span id="amr-cur">{{ ypdt }}'</span>
          <span>/</span>
          <span id="amr-duration">{{ ypleng }}'</span>
        </div>
      </div>
      <!-- <a href="javascript:void(0);" @click="$refs.Imgsee.  visible=true"><img :src="info.url" v-if='info.type==3' width='100%'></a> -->
    </drag-modal>
  </div>
</template>
<script>
import { Tacitly } from '@/assets/js/Tacitly'
import Imgsee from "./img.vue"
import BenzAMRRecorder from 'benz-amr-recorder'
let amr;
export default {
  props: {
    info: {
      type: Object,   //0 视频 1音乐 2pdf  3图片
      default() {
        return {

        }
      }
    },
  },
  data() {
    return {
      visible: false,
      ypleng: 0,
      ypdt: 0,
      shpzt: true

    }
  },
  components: {
    Imgsee
  },
  methods: {
    downFile(i) {
      const baseUrl = process.env.NODE_ENV == "development" ? "https://demo.dyuit.cn/xiaoyin/index.php/api/" : Tacitly.Base_Port;
      return `${baseUrl}common/download?url=${encodeURIComponent(i.url)}&filename=${encodeURIComponent(i.title || i.origin_name)}`
    },
    play(url) {
      let that = this;
      this.shpzt = !this.shpzt
      amr = new BenzAMRRecorder();
      amr.initWithUrl(url).then(function () {
        amr.play();
        that.ypleng = amr.getDuration().toFixed(2)
        var iCount = setInterval(function () {
          let spchang = amr.getCurrentPosition().toFixed(2)
          if (spchang != 0.00) {
            that.ypdt = amr.getCurrentPosition().toFixed(2)
          } else {
            clearInterval(iCount);

          }
        }, 30);

      });
      amr.onEnded(function () {
        that.shpzt = true
        that.ypdt = 0
        //console.log('播放完毕');
      })
      // amr.isPlaying() 返回音频的播放状态 是否正在播放 返回boolean类型
    },
    //停止播放
    playstop() {
      this.shpzt = !this.shpzt
      amr.stop();
    }
  }
}
</script>
<style lang="less" scoped>
.down {
  position: absolute;
  right: 40px;
  top: 15px;
  width: 80px;
  line-height: 30px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  font-size: 14px;
  border-radius: 4px;
}
</style>